/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LaboratoryResearch
 */
export interface LaboratoryResearch {
  /**
   *
   * @type {string}
   * @memberof LaboratoryResearch
   */
  readonly uuid: string;
  /**
   *
   * @type {Date}
   * @memberof LaboratoryResearch
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof LaboratoryResearch
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof LaboratoryResearch
   */
  laboratoryKvkNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof LaboratoryResearch
   */
  gar: string;
  /**
   *
   * @type {string}
   * @memberof LaboratoryResearch
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the LaboratoryResearch interface.
 */
export function instanceOfLaboratoryResearch(value: object): value is LaboratoryResearch {
  if (!("gar" in value) || value["gar"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function LaboratoryResearchFromJSON(json: any): LaboratoryResearch {
  return LaboratoryResearchFromJSONTyped(json, false);
}

export function LaboratoryResearchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LaboratoryResearch {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    laboratoryKvkNumber:
      json["laboratory_kvk_number"] === undefined
        ? undefined
        : json["laboratory_kvk_number"] === null
        ? null
        : json["laboratory_kvk_number"],
    gar: json["gar"],
    dataOwner: json["data_owner"],
  };
}

export function LaboratoryResearchToJSON(json: any): LaboratoryResearch {
  return LaboratoryResearchToJSONTyped(json, false);
}

export function LaboratoryResearchToJSONTyped(
  value?: Omit<LaboratoryResearch, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    laboratory_kvk_number: value["laboratoryKvkNumber"],
    gar: value["gar"],
    data_owner: value["dataOwner"],
  };
}
